import React, { useState, useCallback } from "react";
import rectangleImage from "../../../../../../elements/assets/rectangle.png";
import { Typography, Button, Avatar, Tag, Icon } from "@ann/web-components";
import TagsModal from "../../TagsModal";
import {
  DocumentDetailSlideoutContent,
  SummaryHeader,
  SummaryContent,
  PreviewContainer,
  PreviewImage,
  PreviewButton,
  SectionHeader,
  AccessList,
  AccessItem,
  AccessBullet,
  AvatarGroup,
  TagGroup,
  TagsContainer,
  ActionsRow,
} from "../DocumentDetailSlideout.styled";

export const GeneralContent = ({
  document,
  onRename,
  onShare,
  onManageAgent,
  onManageAccess,
  showActions = true,
  onCloseSlideout,
}) => {
  const [isTagsModalOpen, setIsTagsModalOpen] = useState(false);
  const [documentTags, setDocumentTags] = useState([
    "Product team",
    "Guidelines",
    "Report",
    "Research",
    "Repair",
  ]);

  const handleOpenTagsModal = useCallback(() => {
    onCloseSlideout && onCloseSlideout();
    setIsTagsModalOpen(true);
  }, [onCloseSlideout]);

  const handleCloseTagsModal = useCallback(() => {
    setIsTagsModalOpen(false);
  }, []);

  const handleSaveTags = useCallback(async (newTags) => {
    setDocumentTags(newTags);
    console.log("Saving tags:", newTags);
  }, []);

  const handleAction = useCallback((action) => {
    setIsTagsModalOpen(false);
    action && action();
  }, []);

  return (
    <DocumentDetailSlideoutContent>
      <SummaryHeader>
        <Icon color="primary-alt" name="aiChat" size="medium" />
        <Typography category="subtitle" size="medium" weight="bold">
          Summary
        </Typography>
      </SummaryHeader>

      <SummaryContent>
        <Typography
          category="body"
          maxCharacters={240}
          size="medium"
          weight="regular"
        >
          This report documents a suspected water pump failure on a 2021 Ford
          Explorer. It includes scan results, technician diagnostics, and
          repair notes submitted through the Ford OEM warranty portal for
          validation and reimbursement.
        </Typography>
      </SummaryContent>

      <PreviewContainer>
        <PreviewImage src={rectangleImage} alt="Document preview" />
        <PreviewButton>
          <Button
            iconRight="arrowOutward"
            label="Open Preview"
            pill
            size="small"
            type="primary"
          />
        </PreviewButton>
      </PreviewContainer>

      <SectionHeader>
        <Typography category="subtitle" size="medium" weight="bold">
          Access
        </Typography>
        <Button
          iconLeft=""
          label="Manage Access"
          pill
          size="small"
          type="tertiary"
          onClick={() => handleAction(() => onManageAccess && onManageAccess(document))}
        />
      </SectionHeader>
      <AccessItem>
        <Avatar
          alt="Default avatar"
          size="md"
          src="https://via.placeholder.com/150"
        />
        <Typography category="subtitle" size="small" weight="bold">
          Mike Abbott
        </Typography>
      </AccessItem>

      <AccessList>
        <AvatarGroup>
          <Avatar
            alt="Default avatar"
            size="md"
            src="https://via.placeholder.com/150"
          />
          <Typography category="body" size="medium" weight="regular">
            Emma Wilson
          </Typography>
          <AccessBullet />
          <Typography category="body" size="medium" weight="regular">
            Editor
          </Typography>
          <Tag
            color="informative"
            onClose={() => {}}
            size="medium"
            text="+5"
          />
        </AvatarGroup>
      </AccessList>

      <SectionHeader>
        <Typography category="subtitle" size="medium" weight="bold">
          Connected Agents
        </Typography>
        <Button
          iconLeft=""
          label="Manage Access"
          pill
          size="small"
          type="tertiary"
          onClick={() => handleAction(() => onManageAgent && onManageAgent(document))}
        />
      </SectionHeader>

      <AccessList>
        <AvatarGroup>
          <Avatar
            alt="Default avatar"
            size="md"
            src="https://via.placeholder.com/150"
          />
          <Typography category="body" size="medium" weight="regular">
            Marketing Agent
          </Typography>

          <Tag color="informative" size="medium" text="+3" />
        </AvatarGroup>
      </AccessList>

      <SectionHeader>
        <Typography category="subtitle" size="medium" weight="bold">
          Tags
        </Typography>
        <Button
          iconLeft=""
          label="Edit"
          pill
          size="small"
          type="tertiary"
          onClick={handleOpenTagsModal}
        />
      </SectionHeader>

      <TagsContainer>
        <TagGroup>
          {documentTags.map((tag, index) => (
            <Tag
              key={`${tag}-${index}`}
              color="secondary"
              onClose={() => {}}
              size="medium"
              text={tag}
            />
          ))}
        </TagGroup>
        <Button
          icon=""
          iconLeft="chevronDown"
          label=""
          pill
          size="small"
          type="secondary"
        />
      </TagsContainer>

      {showActions && (
        <ActionsRow>
          <Button
            icon=""
            iconLeft="edit"
            label="Rename"
            size="medium"
            type="secondary"
            onClick={() => onRename && onRename(document)}
          />
          <Button
            icon=""
            iconLeft="share"
            label="Share"
            size="medium"
            type="secondary"
            onClick={() => handleAction(() => onShare && onShare(document, "document"))}
          />
          <Button
            disabled={true}
            icon=""
            iconLeft="download"
            label="Download"
            size="medium"
            type="secondary"
          />
        </ActionsRow>
      )}

      {/* ✅ Tags Modal */}
      <TagsModal
        isOpen={isTagsModalOpen}
        onClose={handleCloseTagsModal}
        onSave={handleSaveTags}
        initialTags={documentTags}
      />
    </DocumentDetailSlideoutContent>
  );
};

